export const PROFILE_TABS_CONFIG = ({ intl }) => [
  { id: 'user', label: intl.formatMessage({ id: 'pages.profile.tabs.user.title' }) },
  { id: 'change-password', label: intl.formatMessage({ id: 'pages.profile.tabs.password.title' }) },
  { id: 'company', label: intl.formatMessage({ id: 'pages.profile.tabs.company.title' }) },
]
